import './shipper-accounts-view/shipper-accounts-view.component';


import './shipper-avatar/shipper-avatar.component';
import './shipper-avatar/shipper-avatar.scss';

import './shipper-detailed-view/shipper-detailed-view.component';

import './shipper-link/shipper-link.component';

import './shipper-list-item/shipper-list-item.component';
import './shipper-list-item/shipper-list-item.scss';

import './shipper-preferences/shipper-preferences.component';
import './shipper-preferences/shipper-preferences.scss';

import './shipper-select-list/shipper-select-list.component';
import './shipper-select-list/shipper-select-list.scss';

import './shippers-list-view/shippers-list-view.component';
import './shippers-list-view/shippers-list-view.scss';

import './shippers-table/shippers-table.component';
import './shippers-table/shippers-table.scss';

import './shippers-table-row/shippers-table-row.component';
import './shippers-table-row/shippers-table-row.scss';
